const LEVEL_TO_PLAYER_IMAGE = {
  division: 'divisionImageUrl',
  branch: 'branchImageUrl',
  section: 'sectionImageUrl',
};

/** Merge roster-file / dashboard root image fields onto structureCards when a card has no logo. */
export function enrichStructureCardsWithPlayerImages(cards, player) {
  if (!Array.isArray(cards) || !cards.length || !player) return cards || [];
  return cards.map((card) => {
    const field = LEVEL_TO_PLAYER_IMAGE[card?.levelKey];
    const fromPlayer = field ? player[field] : null;
    const url = String(card?.divisionImageUrl || fromPlayer || '').trim();
    return {
      ...card,
      divisionImageUrl: url || null,
    };
  });
}

/** Fallback when `structureCards` from the API is empty: roster row still carries labels + logos. */
export function structureCardsFromRosterPlayer(player) {
  if (!player || typeof player !== 'object') return [];
  const levels = [
    { levelKey: 'division', label: player.division, image: player.divisionImageUrl },
    { levelKey: 'branch', label: player.branch, image: player.branchImageUrl },
    { levelKey: 'section', label: player.section, image: player.sectionImageUrl },
  ];
  const out = [];
  for (const L of levels) {
    const name = L.label != null ? String(L.label).trim() : '';
    if (!name) continue;
    const img = L.image != null ? String(L.image).trim() : '';
    out.push({
      levelKey: L.levelKey,
      id: `roster-${L.levelKey}`,
      divisionFullName: name,
      divisionShortName: null,
      elementDetails: null,
      divisionDescription: null,
      divisionImageUrl: img || null,
      elementColor1: null,
      elementColor2: null,
    });
  }
  return out;
}

/** Uses API `structureCards` (UserAssignment.orgDivisionId → UserOrgDivisions, same as roster). */
export function resolveDashboardStructureCards(player) {
  const fromApi = player?.structureCards;
  if (Array.isArray(fromApi) && fromApi.length > 0) {
    return enrichStructureCardsWithPlayerImages(fromApi, player);
  }
  return [];
}

/** Map recap cards to OrgStructureSelector initial selection. */
export function structureCardsToSelection(cards, membershipAssignmentId = null) {
  const sel = {
    divisionId: null,
    branchId: null,
    sectionId: null,
    membershipAssignmentId: null,
  };
  if (!Array.isArray(cards)) return sel;
  for (const c of cards) {
    const id = Number(c?.id);
    if (!Number.isInteger(id) || id < 1) continue;
    if (c.levelKey === 'division') sel.divisionId = id;
    else if (c.levelKey === 'branch') sel.branchId = id;
    else if (c.levelKey === 'section') sel.sectionId = id;
  }
  const mid = Number(membershipAssignmentId);
  if (Number.isInteger(mid) && mid > 0) {
    sel.membershipAssignmentId = mid;
  }
  return sel;
}
